import {useQuery} from "react-query";
import timesheetService from "../../services/timesheetService";

const useMyVisits = ({page = 0, rowsPerPage = 5}) => useQuery(['my-visits', page,  rowsPerPage], () => timesheetService.fetchMyVisits({page, rowsPerPage}), 
    {
        keepPreviousData: true
    })

export default useMyVisits